export default __webpack_public_path__ + "static/media/male_afro.7fe721af.png";